<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="d-flex flex-wrap inputContainer" :class="{'flex-column' : question.options.length > 2}">
      <div
          class="quill-question-input radio"
          :class="{
        'me-4': question.options.length === 2 && index === 0,
        'mb-2': question.options.length > 2 && index + 1 !== question.options.length,
        invalid: error && hasBeenInteractedWith,
      }"
          v-for="(option, index) in question.options"
          :key="index"
      >

        <label :for="`${question.name}-radio-${option.value}`" :class="{selected: currentValue === option.value && !this.error} ">
          <input
              v-bind="$attrs"
              type="radio"
              :disabled="disabled"
              :name="question.name"
              :id="`${question.name}-radio-${option.value}`"
              :value="option.value"
              :checked="currentValue === option.value"
              @click.stop="$emit('user-interaction')"
              @change="validate(option)"
          />
          <span>{{ option.text }}</span>
        </label>
      </div>
    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !error" :isError="error"
          :confirmCb="() =>{$emit('user-interaction') ;$emit('confirm'); }"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="currentValue ? currentValue:'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";

export default {
  name: "RadioChoice",
  components: {ReadOnly},
  props: ["question", "modelValue",'hideSubText','skipEagerValidation','disableConfirm','forcePromptPlaceholder','hasBeenInteractedWith','disabled'],
  emits: ["update:modelValue", "field-error",'confirm','user-interaction'],
  data() {
    return {
      currentValue: null,
      error:this.question.error || '',
    };
  },
  mounted() {
    this.currentValue = this.question.value;

    if(!this.skipEagerValidation){
      this.error = this.question.error
      if(this.error ){
        return this.$emit('field-error', true)
      }
      this.validate()
    }
  },
  methods:{
    validate(option){
      this.currentValue = option ? option.value: this.currentValue;
      if(!this.currentValue && this.question.required){
        this.error='Required'
        return this.$emit('field-error', true)
      }else{
        this.error=''
        this.$emit('update:modelValue',  this.currentValue);
        this.$emit('field-error', false)
      }
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        if(newQuestion.value !== undefined && newQuestion.value  !== this.currentValue){
          this.currentValue = newQuestion.value
          this.validate();
        }
        if (newQuestion.error) {
          this.error = newQuestion.error
          return this.$emit('field-error', true)
        }
      },
      deep: true,
    }
  },
};
</script>

<style scoped lang="scss">
.align-text-end{
  text-align: end;
}
.subtext {
  font-size: 12px;
  color: #757575;
}
.errorMessage {
  color: #BB0000
}

.quill-question {
  > label {
    display: flex;
    justify-content: space-between;

    > span {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 4px;
      color: #212121;
    }

    > i {
      font-style: normal;

      > svg {
        width: 14px;
        height: 14px;
        cursor: pointer;
        float: right;
        margin: 5px;
        border-radius: 50%;
        line-height: 16px;
        opacity: 0.7;

        &:hover {
          color: red;
          box-shadow: 0 1px 5px 0 #9d9b9b;
        }
      }

      > span {
        position: absolute;
        top: 26px;
        right: 0;
        width: 275px;
        font-size: 14px;
        background: #212121;
        color: #ffffff;
        padding: 10px;
        border-radius: 4px;
        text-align: left;
        z-index: 9;
        visibility: hidden;
        transition-delay: 1s;

        &:before {
          content: " ";
          position: absolute;
          top: -8px;
          right: 8px;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent black transparent;
        }
      }
    }
  } 

  > div.inputContainer {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;

    > .quill-question-input {
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 16px 5px;
      width: 100%;
      font-size: 16px;
      background: transparent;
      min-height: 100%;

      &:has(~ .question-type-unknown) {
        border-color: red;
      }

      &:hover, &:focus, &:has(.selected) {
        outline: none;
        border-color:#212121;
        box-shadow: 0 0 0 1px #212121 !important;
        padding: 0px !important;
      }


      &.radio {
        padding: 0;
        /*margin: 3px;*/
        min-width: 0;
        height: 51px;
        flex: 1;
        box-sizing: border-box;

        > label {
          padding: 12px 2px;
          cursor: pointer;
          white-space: nowrap;
        }

        input {
          margin: 0 10px;
          transform: scale(1.3);
          accent-color: #212121;
        }
      }

      label {
        width: 100%;
      }
    }

    > .question-type-unknown {
      color: red;
      position: absolute;
      right: 10px;
      top: -10px;
      background: white;
    }

    .quill-question-placeholder {
      position: absolute;
      padding: 14px 16px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: 0.26s all ease;
    }
  }

  &.error {
    > b {
      display: block;
    }

    > div {
      border-color: red;
    }
  }
}

.invalid {
  border: 1px solid #bb0000 !important;

  &:hover,
  &:focus,
  &:focus-within {
    border-color:#bb0000;
    box-shadow: 0 0 0 1px #bb0000 !important;
  }
}
</style>
